import { Component, OnInit, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { SiteState } from '../shared/models';
import { getCropYear } from '../store/selectors';

@Component({
  selector: 'app-field-plan-customer-selection-custom-config',
  standalone: false,
  templateUrl: './customer-selection-custom-config.component.html',
})
export class FieldPlanCustomerSelectionCustomConfigComponent implements OnInit {
  protected readonly store = inject<Store<SiteState>>(Store);

  cropYear: number;
  cropYear$ = this.store.pipe(select(getCropYear));

  ngOnInit(): void {
    this.cropYear$.subscribe((cropYear) => {
      if (cropYear) {
        this.cropYear = cropYear;
      } else {
        this.cropYear = new Date().getFullYear();
      }
    });
  }
}
